import { Grid, Typography, Hidden } from '@material-ui/core'
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'
import { pictureUrl } from '../common/pictureUrl'
import React from 'react'

export const NewHero = () => {
  const site = useSelector(({ site }) => site)

  return (
    <Grid container justifyContent="space-evenly" alignItems="center" spacing={4}>
      <Grid item xs={12} sm={6}>
        <Typography variant="h1">
          {site.entity_as_json.whitemark_tagline}
        </Typography>
        <Typography variant="overline">
          <a href="#presentation">
            <Trans i18nKey="main.whitemark.link_to_presentation" />
          </a>
        </Typography>
      </Grid>

      <Hidden xsDown>
        <Grid item xs={12} sm={6}>
          <img src={pictureUrl({ record_type: 'Company', record_id: site.entity_id, name: 'whitemark_hero' }, 400, 300)} alt="Hero" width='100%' />
        </Grid>
      </Hidden>
    </Grid>
  )
}
